import React from "react"
import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import { BottomSheetAction } from "types/general.types"
import theme from "lib/material-ui/theme"
import { ITEM } from "constants/index"
import BottomSheet from "components/atoms/BottomSheet"
import BottomSheetMenuItem from "components/molecules/BottomSheetMenuItem"
import withRoleBasedPermission from "components/HOCs/withRoleBasedPermission"

type WishItemActionsBottomSheetProps = {
  show: boolean;
  actions: BottomSheetAction[];
  onOpen: () => void;
  onClose: (selectedLists: number[]) => void;
}

const BottomSheetMenuItemWithRoleBasedPermission = withRoleBasedPermission(BottomSheetMenuItem)

export default function WishItemActionsBottomSheet(props: WishItemActionsBottomSheetProps) {
  const { show, actions = [], onOpen, onClose } = props

  const { t } = useTranslation()

  return (
    <BottomSheet
      id="wishitem-actions-bottom-sheet"
      title={""}
      show={show}
      openBottomSheet={onOpen}
      closeBottomSheet={onClose}
    >
      <Stack gap={"24px"}>
        {actions.map(action => (
          <BottomSheetMenuItemWithRoleBasedPermission
            key={action.key}
            resource={ITEM}
            action={action.key}
            premiumPermissionKey={action.premiumPermissionKey}
            icon={action.icon}
            label={t(action.labelKey)}
            color={action.getColor ? action.getColor(theme) : undefined}
            onClick={() => document.dispatchEvent(new CustomEvent(action.eventName))}
          />
        ))}
      </Stack>
    </BottomSheet>
  )
}
